/**
 * Portal version toggle for the new admin experience.
 *
 * PortalVersion.CURRENT_PORTAL (value 0) — new admin experience disabled (default).
 * PortalVersion.NEW_PORTAL (value 1)     — new admin experience enabled.
 *
 * The enum name ("PortalVersion") and the corresponding database column name
 * ("portal_version") are legacy names retained for backward compatibility.
 * They continue to be used as-is so that no database migration is needed.
 */
import RoleID from 'src/app/data/common/interfaces/RoleID';

export enum PortalVersion {
  CURRENT_PORTAL,
  NEW_PORTAL,
}

type PortalVersionType = number | undefined | null;

export const PORTAL_VERSION_VALUES = {
  [PortalVersion.CURRENT_PORTAL]: {
    label: 'MursionPortal.Label.OldPortal',
  },
  [PortalVersion.NEW_PORTAL]: {
    label: 'MursionPortal.Label.NewPortal',
  }
};

/**
 * True when this learner belongs to the new portal rather than this one.
 *
 * Used by the post-sim survey bridge to tell the in-house survey where to send the learner afterwards.
 * The survey is served by the new portal, so without an explicit answer it cannot tell the two apps'
 * learners apart — and the site root is not a safe stand-in, because `/` lands here and this app only
 * auto-forwards account owners (see redirectToNewExperience), leaving a new-portal learner on our
 * dashboard.
 */
export const isNonCurrentPortalVersionForLearner = (portalVersion: PortalVersionType, roleID: string | undefined) => {
  if (portalVersion === undefined || portalVersion === null) {
    return false;
  }
  return portalVersion !== PortalVersion.CURRENT_PORTAL && roleID === RoleID.LEARNER;
};
